var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7125 13.4736L16.9624 12.2238C17.1576 12.0285 17.4974 12.1652 17.4974 12.4464V18.1253C17.4974 19.1603 16.6577 20 15.6227 20H1.87473C0.839721 20 0 19.1603 0 18.1253V4.37729C0 3.34228 0.839721 2.50256 1.87473 2.50256H12.5568C12.8341 2.50256 12.9747 2.83845 12.7794 3.03764L11.5296 4.28746C11.471 4.34604 11.3929 4.37729 11.3069 4.37729H1.87473V18.1253H15.6227V13.6923C15.6227 13.6103 15.654 13.5322 15.7125 13.4736ZM21.8288 5.59195L11.5725 15.8483L8.04179 16.2388C7.0185 16.3521 6.14754 15.4889 6.2608 14.4578L6.65137 10.9271L16.9077 0.6708C17.8021 -0.2236 19.2472 -0.2236 20.1377 0.6708L21.8249 2.35805C22.7193 3.25245 22.7193 4.70146 21.8288 5.59195ZM17.97 6.79881L15.7008 4.52961L8.44408 11.7903L8.15896 14.3407L10.7094 14.0556L17.97 6.79881ZM20.5009 3.68598L18.8137 1.99873C18.6535 1.8386 18.3918 1.8386 18.2356 1.99873L17.0288 3.20559L19.298 5.47478L20.5048 4.26793C20.661 4.10389 20.661 3.84612 20.5009 3.68598Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2d626f8265dce128d32d0285fd7f6cd3.svg";
export { ForwardRef as ReactComponent };